import { connect } from "react-redux";
import SalesforceAddressSetup from "../components/AccountSetting/Salesforce/SalesforceAddressSetting/SalesforceAddressSetup";
import { goBack, push, replace } from "react-router-redux";
import * as actions from "../redux/actions/Salesforce";
import { getUser } from "../redux/actions/AccountSetting";
import { SalesforceSettingDirectory } from "../constants/ComponentTypes";
import { initializeMessage } from '../redux/actions/Common';
import { jobCompleted } from "../redux/actions/Broadcasting";

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  tab: SalesforceSettingDirectory.ADDRESS_BOOK.value,
  sobject_name: state.sfdcAddressSetting.sobject_name,
  listview_id: state.sfdcAddressSetting.listview_id,
  listviews: state.sfdcAddressSetting.listviews,
  isLoadingMapping: state.sfdcAddressSetting.isLoadingMapping,
  isLoadingPreview: state.sfdcAddressSetting.isLoadingPreview,
  isLoadingListviews: state.sfdcAddressSetting.isLoadingListviews,
  isLoadingFields: state.sfdcAddressSetting.isLoadingListviews,
  isJobCompletedLoading: state.broadcasting.isJobCompletedLoading,
  fields: state.sfdcAddressSetting.fields,
  preview: state.sfdcAddressSetting.preview,
  mapping: state.sfdcAddressSetting.mapping,
  errorMessage: state.sfdcAddressSetting.errorMessage,
  shortMessage: state.sfdcAddressSetting.shortMessage,
  successMessage: state.sfdcAddressSetting.successMessage || state.broadcasting.jobSuccessMessage,
  loadingPreviewFailed: state.sfdcAddressSetting.loadingPreviewFailed,
  expiredAccessError: state.sfdcAddressSetting.expiredAccessError,
  isConfiguring: state.salesforce.isConfiguring,
  isLoadingConfig: state.salesforce.isLoadingConfig,
  address_import_mappings_flag: state.salesforce.address_import_mappings_flag,
  exe_export_mappings_flag: state.salesforce.exe_export_mappings_flag,
  salesforce_integration_setting_id:
    state.salesforce.salesforce_integration_setting_id,
});

const mapDispatchToProps = (dispatch) => ({
  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  replace(url, state) {
    dispatch(replace(url, state));
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getSalesforceDescribe(sobject_name) {
    dispatch(actions.getSalesforceDescribe(sobject_name));
  },

  getSalesforceListviews(sobject_name) {
    dispatch(actions.getSalesforceListviews(sobject_name));
  },

  getSalesforcePreview(sobject_name, data) {
    dispatch(actions.getSalesforcePreview(sobject_name, data));
  },

  configAndSync(data) {
    dispatch(actions.configAndSync(data));
  },

  postSalesforceConfig(data) {
    dispatch(actions.postSalesforceConfig(data));
  },

  postSalesforceSync() {
    dispatch(actions.postSalesforceSync());
  },

  getSalesforceConfig() {
    dispatch(actions.getSalesforceConfig());
  },

  initializeMessage() {
    dispatch(initializeMessage());
  },

  jobCompleted(userId) {
    dispatch(jobCompleted(userId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceAddressSetup);



// WEBPACK FOOTER //
// ./src/containers/SalesforceAddressSetup.js